// Undo suppress → open form for Threat Insights.
// Mirrors SilenceThreatForm layout: reason + Cancel / Undo actions.

import React from "react";
import PropTypes from "prop-types";
import { Stack, Typography } from "@mui/material";

import { SafeTextField } from "../../../common/Greens";
import { CancelButton, SaveButton } from "../../../common/Button";
import { TEXT_PRIMARY, TEXT_SECONDARY } from "../detection/wafEventDrawerShared";

export default function UndoSuppressForm({ saving, onCancel, onSubmit }) {
  const [reason, setReason] = React.useState("");

  React.useEffect(() => {
    setReason("");
  }, []);

  const trimmed = reason.trim();
  const reasonInvalid = !trimmed || trimmed.length > 500;

  const handleSubmit = () => {
    if (reasonInvalid) return;
    onSubmit({ reopen_reason: trimmed });
  };

  return (
    <Stack spacing={2} sx={{ width: "100%" }}>
      <Typography sx={{ fontSize: 13, color: TEXT_SECONDARY, lineHeight: 1.45 }}>
        Reopen this finding to <b>open</b>. The scanner can surface it again on the next tick.
      </Typography>

      <SafeTextField
        label="Reason"
        size="small"
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        multiline
        maxRows={3}
        inputProps={{ maxLength: 500 }}
        helperText="Saved in suppress & silence notes (who / when / why)."
        required
        error={Boolean(reason) && reasonInvalid}
        sx={{
          backgroundColor: "#fff",
          "& .MuiOutlinedInput-root": { fontSize: 13 },
          "& .MuiInputLabel-root": { color: TEXT_PRIMARY },
        }}
      />

      <Stack direction="row" spacing={1.5} justifyContent="flex-end" alignItems="center">
        <CancelButton
          onClick={onCancel}
          disabled={saving}
          sx={{ width: "auto", minWidth: 104, height: 36 }}
        />
        <SaveButton
          onClick={handleSubmit}
          disabled={reasonInvalid}
          loading={saving}
          label="Undo"
          sx={{ width: "auto", minWidth: 104, height: 36 }}
        />
      </Stack>
    </Stack>
  );
}

UndoSuppressForm.propTypes = {
  saving: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

UndoSuppressForm.defaultProps = {
  saving: false,
};
